import React from "react";
import styles from "./index.module.scss";
import Page from "../Page";
import { tgLink } from "../../constants";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <section className={styles.footer}>
      <Page notPadding>
        <div className={styles.cnt}>
          <div className={styles.site}>Fantasy UPL 2024</div>
          <div className={styles.links}>
            <a href={tgLink}>Зв'язатися з нами</a>
            <Link to="/terms-of-service">Користувальницька угода</Link>
            <Link to="/privacy-policy">Політики приватності</Link>
          </div>
        </div>
      </Page>
    </section>
  );
};

export default Footer;
